import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Moment from "moment";
import {Button as Buttonmui} from "@mui/material";
import Box from "@mui/material/Box";

import axios from "axios";
import { security_key, BASE_URL } from "../global";
import { ToastContainer,toast } from "react-toastify";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {number} from "yup";
import { getMomentLocaleTimeFormat } from "./Calendar-util";
import { getUserSetting } from "./UserSetting";


/**
 * Represents a SessionRecord.
 * @typedef {Object} SessionRecord
 * @property {string} pk_sest_key
 * @property {string} sest_name
 * @property {string} tut_fname
 * @property {string} tut_surname
 * @property {string} sest_from_date
 * @property {string} sest_to_date
 * @property {string} sest_start_time
 * @property {string} sest_end_time
 * @property {number} sest_max_student
 * @property {number} enrolment_count
 */
/*
* @param {SessionRecord[], boolean} {records, loading}
*/
export const ListSessionTimeTable= ({records, loading})=> {

    const userSetting = getUserSetting();
    const hasRows = records.length > 0;

    const columns = [
        {
            headerName: "Session Name",
            field: "Session Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${
                    params.row.sest_name === null || params.row.sest_name === ""
                        ? "-"
                        : params.row.sest_name
                }`;
            },
        },
        {
            headerName: "Day",
            field: "Day",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${
                    params.row.sest_day === null || params.row.sest_day === ""
                        ? "-"
                        : params.row.sest_day
                }`;
            },
        },
        {
            headerName: "Tutor",
            field: "Tutor",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${
                    params.row.tut_fname === null || params.row.tut_fname === ""
                        ? "-"
                        : params.row.tut_fname + " " + params.row.tut_surname
                }`;
            },
        },
        {
            headerName: "Start - End Date",
            field: "Start - End Date",
            headerClassName: "super-app-theme--header",
            //flex: 1,
            width: 200,
            valueGetter: (params) => {
                return `${
                    (params.row.sest_from_date === null ||
                        params.row.sest_from_date === "") &&
                    (params.row.sest_to_date === null || params.row.sest_to_date === "")
                        ? "-"
                        : Moment(params.row.sest_from_date, "YYYY-MM-DD").format(
                            "DD-MM-YYYY"
                        ) +
                        " - " +
                        Moment(params.row.sest_to_date, "YYYY-MM-DD").format("DD-MM-YYYY")
                }`;
            },
        },
        {
            headerName: "Start - End Time",
            field: "Start - End Time",
            headerClassName: "super-app-theme--header",
            //flex: 1,
            width: 120,
            valueGetter: (params) => {
                return `${
                    (params.row.sest_start_time === null ||
                        params.row.sest_start_time === "") &&
                    (params.row.sest_end_time === null || params.row.sest_end_time === "")
                        ? "-"
                        : getMomentLocaleTimeFormat(params.row.sest_start_time, "HH:mm:ss", userSetting.locale) +
                        " - " +
                        getMomentLocaleTimeFormat(params.row.sest_end_time, "HH:mm:ss", userSetting.locale)
                }`;
            },
        },
        {
            headerName: "Students",
            field: "Students",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${
                    params.row.enrolment_count +
                    " / " +
                    (params.row.sest_max_student !== null &&
                    params.row.sest_max_student !== ""
                        ? params.row.sest_max_student
                        : "0")
                }`;
            },
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Action",
            headerClassName: "super-app-theme--header",
            width: 200,
            headerAlign: "left",
            renderCell: (params) => {
                const row = params.row;

                return (
                    <div className="d-flex  pad-12">
                        <Buttonmui
                            variant="outlined-red"
                            onClick={() => handleSessionClick(row)}
                            className="primary-blue  btnmr-2 my-2"
                        >
                            View Sessions{" "}
                        </Buttonmui>
                        <Buttonmui
                            variant="outlined-red"
                            onClick={() => handleRowEditSessionClick(row)}
                            className="primary-blue  btnmr-2 my-2"
                        >
                            Edit
                        </Buttonmui>
                    </div>
                );
            },
        },
    ];

    const navigate = useNavigate();
    const handleSessionClick = async (e) => {
        navigate(`/list-session`, { state: { pk_sest_key: `${e.pk_sest_key}` } });
    };

    function toDate(dateStr, timeStr) {
        return new Date(
            `${dateStr}T${timeStr}`
        );
    }

    const handleRowEditSessionClick = async (e) => {
        const responsetime = await axios
            .post(BASE_URL + "API/api_index.php", {
                security_key: security_key,
                fk_cent_key: sessionStorage.getItem("key"),
                mode: "getCheckTimeZone",
            })
            .then((responsetime) => {
                if (responsetime.data.data.length > 0) {
                    if (
                        responsetime.data.data[1] !== null &&
                        responsetime.data.data[1] !== ""
                    ) {
                        const currentDate = toDate(responsetime.data.data[0], responsetime.data.data[1])

                        // Set the session_date (assuming it's a string, convert it to a Date object)
                        const session_date = toDate(e.sest_from_date, e.sest_start_time);

                        // Compare dates using getTime() method
                        if (currentDate.getTime() <= session_date.getTime() && e.enrolment_count <= 0) {
                            navigate(`/edit-session-time`, {
                                state: { pk_sest_key: `${e.pk_sest_key}` },
                            });
                        }

                        else {
                            navigate(`/edit-existing-session-time`, {
                                state: { pk_sest_key: `${e.pk_sest_key}` },
                            });
                        }
                    } else {
                        toast.error(
                            "Failure! Unable to Editable session. Try again later",
                            {
                                autoClose: 700, // 3 seconds in this example
                            }
                        );
                    }
                } else {
                    toast.error("Failure! Unable to Editable session. Try again later", {
                        autoClose: 700, // 3 seconds in this example
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                toast.error("Failure! Unable to Editable session. Try again later", {
                    autoClose: 700, // 3 seconds in this example
                });
            });
    };


    return (
        <>
            <ToastContainer/>
            <Row>
                <Col xs="12">
                    <div className="">
                        <Row className="justify-content-center">
                            {/* --------------Table Content Start--------------- */}
                            <Col sm={12}>
                                <Box
                                    sx={{
                                        height: hasRows ? "auto" : 200,
                                        maxHeight: "calc(100vh - 270px)",
                                        width: "100%",
                                        "& .actions": {
                                            color: "text.secondary",
                                        },
                                        "& .textPrimary": {
                                            color: "text.primary",
                                        },
                                        "& .super-app-theme--header": {
                                            backgroundColor: "#e3e6ee",
                                        },
                                    }}
                                    style={{ width: "100%" }}
                                >
                                    <DataGrid
                                        sx={{
                                            maxHeight: "calc(100vh - 270px)",
                                        }}
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                            toolbar: GridToolbar,
                                        }}
                                        slotProps={{
                                            toolbar: {
                                                csvOptions: { fileName: "SessionList" },
                                                printOptions: {
                                                    pageStyle: `@media print {
                                                          @page {
                                                            size: A4 landscape;
                                                            margin: 0;
                                                          }
                                                    }`,
                                                    disableToolbarButton: true,
                                                    hideFooter: true,
                                                    hideToolbar: true,
                                                    fileName: "SessionList",
                                                },
                                                records,
                                                showQuickFilter: true,
                                            },
                                        }}
                                        // showQuickFilter={true}
                                         pagination={false}
                                         hideFooterPagination
                                         hideFooter
                                        loading={loading}
                                        rows={records.map((row, index) => ({
                                            ...row,
                                            id: `row-${index}`,
                                        }))}
                                        columns={columns}
                                        rowHeight={60}
                                        density="compact"
                                        // onRowClick={(params) => handleRowEditSessionClick(params.row)}
                                        disableRowSelectionOnClick
                                        showCellVerticalBorder={true}
                                        showColumnVerticalBorder={true}
                                    />
                                </Box>
                            </Col>
                            {/* --------------Table Content Start--------------- */}
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )
}